import axios from 'axios';
import { getLoanPaymentsQuery } from '../queries';
import parseError from '../errors/utils';

const getLoanPayments = async ({ startDate, endDate }) => {
    try {
        const loanPayments = await axios.get(getLoanPaymentsQuery({ startDate, endDate }));
        return { loanPayments: loanPayments?.data };
    } catch (error) {
        return { error: parseError({ error }) };
    }
};

export default getLoanPayments;
